<template>
  <Alert
    :data="{
      alertbar_active: isPreview || isDebug,
      alertbar_text: `${isPreview ? 'Preview' : isDebug ? 'Debug' : ''} mode active`,
    }"
  />
  <!-- <FormLoader :theme="theme" /> -->
  <ModalLoader v-if="formStatus === 'loading'" :t="t" />
  <Header :theme="theme" :home-url="homeUrl" />

  <slot />

  <DebugBox v-if="isDebug" :steps="debugSteps" :urls="debugUrls" :show="isDebug" />
  <Footer :theme="theme" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ModalLoader } from 'refresh-ui'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import Alert from '@/components/atoms/Alert.vue'
import DebugBox from '@/components/molecules/DebugBox.vue'
import Header from '@/components/elements/SimpleHeader.vue'
import Footer from '@/components/elements/SimpleFooter.vue'
import { THEMES } from '~/libs/themes'

const { t } = useI18n()
const route = useRoute()
const config = useRuntimeConfig()

// Expects these to be injected from the page via definePageMeta
const page = route.meta

const isPreview = computed(() => route.query.preview === 'true')
const isDebug = computed(() => route.query.debug === 'true')

const debugSteps = computed(() => page.debugSteps || [])
const debugUrls = computed(() => page.debugUrls || {})
const formStatus = computed(() => page.formStatus || 'idle')
const homeUrl = computed(() => {
  return typeof page.homeUrl === 'string' && page.homeUrl.length > 0
    ? page.homeUrl
    : config.public.SITE_PARENT || '/'
})
function isTheme(val: unknown): val is THEMES {
  return typeof val === 'string' && (Object.values(THEMES) as string[]).includes(val)
}
const theme = computed(() => {
  return isTheme(page.theme) ? page.theme : THEMES.DEFAULT
})
</script>
